module.exports = __webpack_public_path__ + "static/media/vivi-mostrandoabaixo-direita.139a9f8a.svg";